<template>
  <div style="width: 100%;">
    <v-container fluid>
      <v-row>
        <v-col class="d-flex flex-row align-center">
          <h1>{{this.plural}}</h1>
          <v-btn
            v-if="this.isAllowed('user', 'c')"
            class="mx-2"
            fab
            small
            dark
            color="info"
            @click="openCreateStocktakingEventDialog"
          >
            <v-icon dark>
              mdi-plus
            </v-icon>
          </v-btn>
          <v-progress-circular
            indeterminate
            color="green"
            v-if="loader"
            style="margin-left: 10px;"
          ></v-progress-circular>
        </v-col>
      </v-row>
      <v-row>
        <v-col>
          <v-card>
            <v-data-table
                :headers="headers"
                :items="data"
                :options.sync="options"
                :server-items-length="pagination.dataCount"
                :loading="pagination.loading"
                :items-per-page="-1"
                class="elevation-1"
                :footer-props="{
                  itemsPerPageOptions: pagination.pageSizeOptions
                }"
                @click:row="rowClick"
                @mousedown:row="rowMiddleClick"
            >
              <template v-slot:item.createdBy="{ item }">
                <span>{{lookupUsername(item.createdBy)}}</span>
              </template>
              <template v-slot:item.startedAt="{ item }">
                <span v-if="item.startedAt">{{utils.formatDate(item.startedAt, 'withTime')}}</span>
                <span v-else>-</span>
              </template>
              <template v-slot:item.endedAt="{ item }">
                <span v-if="item.endedAt">{{utils.formatDate(item.endedAt, 'withTime')}}</span>
                <span v-else>-</span>
              </template>
              <template v-slot:item.strict="{ item }">
                <span v-if="item.metadata">{{item.metadata.strict?'✅':'❌'}}</span>
                <span v-else>-</span>
              </template>
              <template v-slot:item.productCounts="{ item }">
                <span v-if="item.productCounts">{{item.productCounts.length}}</span>
                <span v-else>-</span>
              </template>
              <template v-slot:item.status="{ item }">
                <v-chip :color="utils.getStocktakingEventStatusColor(item.status)">{{utils.parseStocktakingEventStatus(item.status)}}</v-chip>
              </template>
            </v-data-table>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
    <v-snackbar v-model="snackObj.state" :timeout="3000" :color="snackObj.color">
      {{ snackObj.text }}
      <template v-slot:action="{ attrs }">
        <v-btn v-bind="attrs" text @click="snackObj.state = false">Close</v-btn>
      </template>
    </v-snackbar>
    <v-dialog v-model="createStocktakingEventDialog.isOpen" width="500">
          <v-card>
            <v-card-title>Create {{ singular }}</v-card-title>
            <v-card-text>
              Options:
              <v-checkbox
                v-model="createStocktakingEventDialog.data.metadata.strict"
                label="Strict Mode"
              />
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="success" :loading="createStocktakingEventDialog.isLoading" @click="create">Create</v-btn>
              <v-btn color="info" @click="closeCreateStocktakingEventDialog">Cancel</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
  </div>
</template>
<script>
  import axios from 'axios';
  import { mapGetters } from "vuex"
  import utils from "../../plugins/helpers"
  export default {
    data () {
      return {
        utils: utils,
        deleteDialog: false,
        deleteConfirmed: true,
        loader: true,

        snackObj: {
          state: false,
          color: '',
          text: ''
        },

        max25chars: v => v.length <= 25 || 'Input too long!',
        headers: [
          { text: 'ID', align: 'start', sortable: true, value:'id'},
          { text: 'Status', align: 'start', sortable: true, value:'status'},
          { text: 'Created By', sortable: true, value: 'createdBy'},
          { text: 'Started', value: 'startedAt' },
          { text: 'Ended', value: 'endedAt' },
          { text: 'Strict Mode', sortable: true, value: 'strict' },
          { text: 'SKUs Counted', value: 'productCounts' },
        ],

        pagination: {
          loading: false,
          dataCount: 0,
          pageSizeOptions: [5, 10, 15, 30, -1]
        },
        options: {
          search: "",
          sortBy: ['id'],
          sortDesc: [false],
          page: 1,
          itemsPerPage: -1
        },
        updatingRoute: false,
        init: false,

        editMode: false,
        data: [],
        singular: "Stocktaking Event",
        singularLower: "stocktakingEvent",
        plural: "Stocktaking Events",
        pluralLower: "stocktakingEvents",
        createStocktakingEventDialog: {
          isOpen: false,
          isLoading: false,
          data: {
            metadata: {
              strict: false
            }
          }
        }
      }
    },
    async created(){
      try{
        //used for pagination
        let oldQuery = this.getURLQuery();
        this.options.page = oldQuery.page || 1;
        this.options.itemsPerPage = oldQuery.limit || -1
        this.options.sortBy = [oldQuery.sort || "name"]
        this.options.sortDesc = [oldQuery.order || true]
        this.options.search = oldQuery.search || ""
        //used for pagination end
      }
      catch (error) {
        console.error(error)
        this.snack(error.msg || error.msg?.message || error, "error");
      }
    },
    async mounted(){
      this.init = true;

      this.pagination.pageSizeOptions = this.getGlobalValue("paginationPageLimitsGeneral")?.split(",").map(x => parseInt(x)) || this.pagination.pageSizeOptions;

      await this.getAllData();
      this.init = false;
    },
    computed: {
      ...mapGetters(['getUser', 'getId', 'getToken', 'isAllowed', 'getEndpoint', 'getGlobalValue','lookupUsername'])
    },
    watch: {
      options: {
        async handler () {
          await this.getAllData();
        },
        deep: true,
      },
      $route: {
        handler: async function (current) {
          //used for pagination
          if (this.updatingRoute) return;
          let oldQuery = this.getURLQuery(current.query);
          this.options.page = oldQuery.page || 1;
          this.options.itemsPerPage = oldQuery.limit || -1
          this.options.sortBy = [oldQuery.sort || "name"]
          this.options.sortDesc = [oldQuery.order || true]
          this.options.search = oldQuery.search || ""
          //used for pagination end include full watcher
        },
        deep: true
      }
    },
    methods: {      
      openCreateStocktakingEventDialog(){
        this.createStocktakingEventDialog.isOpen = true
      },
      closeCreateStocktakingEventDialog(){
        this.createStocktakingEventDialog.isOpen = false
        this.createStocktakingEventDialog.isLoading = false
        this.createStocktakingEventDialog.data = {
          metadata: {
            strict:false
          }
        }
      },
      async secureEmailPasswordReset(){
        try {
          let res = await axios.post(`${this.getEndpoint}/api/users/secureResetPassword`)
          console.log(res)
        } catch (error) {
          console.log(error)
        }
      },
      //used for pagination
      getURLQuery(custom=null){
        let oldQuery = custom? {...custom}: {...this.$route.query};
        if(oldQuery.limit) oldQuery.limit = parseInt(oldQuery.limit);
        if(oldQuery.page) oldQuery.page = parseInt(oldQuery.page);
        if(oldQuery.order) oldQuery.order = oldQuery.order==='true';
        return oldQuery;
      },
      //used for pagination end
      rowClick(row){
        this.$router.push({ path: `/${this.pluralLower}/view/${row.id}`})
      },
      async rowMiddleClick(event, row){
        if(!row.item) return;
        row = row.item;

        if (event.button === 1) {
          event.preventDefault();
          this.utils.openInNewTab(this.$router,`/${this.pluralLower}/view/${row.id}`)
        }
      },
      async create(){
        try {
          this.closeCreateStocktakingEventDialog.isLoading = true
          
          let obj = this.createStocktakingEventDialog.data
          let res = await axios.post(`${this.getEndpoint}/api/stocktakingEvents/`, obj)
          
          if(res.data.error) throw res.data.error
          this.snack('Success! Stocktaking Event Created.')

          if(res.data.err) throw res.data.err
        } catch (error) {
          console.log(error)
          this.snack(error.msg)
        } finally {
          this.closeCreateStocktakingEventDialog()
        }
      },
      snack(text, color=""){
        this.snackObj.text = text;
        this.snackObj.state = true;
        this.snackObj.color = color;
      },
      formatPrice(value){
        if(value===null) return "";
        let formatter = new Intl.NumberFormat('en-US', {
          style: 'currency',
          currency: 'USD'
        });
        return formatter.format(parseFloat(value));
      },
      async getAllData(){
        try {
          //used for pagination
          this.pagination.loading = true;
          let paginationData = {
            page: this.options.page,
            limit: this.options.itemsPerPage,
            sort: "id",
            order: this.options.sortDesc[0],
            search: this.options.search
          }
          console.log(paginationData)
          let uriFields = Object.keys(paginationData).map(x => {
            return x + "=" + (paginationData[x]!==undefined?encodeURIComponent(paginationData[x]):'')
          }).join("&");
          //used for pagination end

          console.log(uriFields)
          let res = await axios.get(`${this.getEndpoint}/api/${this.pluralLower}/tableDataPaginated?${uriFields}`)
          if(res.data.error) throw res.data.error

          this.data = res.data.data

          //used for pagination
          this.pagination.dataCount = res.data.total
          let shouldUpdate = false;
          let oldQuery = this.getURLQuery();
          let newQuery = {...paginationData};
          if(Object.keys(newQuery).length!==Object.keys(oldQuery).length) shouldUpdate = true;
          if(!shouldUpdate){
            for(let key of Object.keys(newQuery)){
              if(shouldUpdate) break;

              if(Array.isArray(newQuery[key])){
                if(newQuery[key].length!==oldQuery[key].length){
                  shouldUpdate = true;
                  break;
                }
                for(let i=0;i<newQuery[key].length-1;i++){
                  if(newQuery[key][i]!==oldQuery[key][i]){
                    shouldUpdate = true;
                    break;
                  }
                }
              }
              else if(newQuery[key]!==oldQuery[key]){
                shouldUpdate = true;
              }
            }
          }

          if(shouldUpdate){
            this.updatingRoute = true;
            if(this.init){
              if(this.$route.path===`/${this.pluralLower}`) await this.$router.replace({path: `/${this.pluralLower}`, query: newQuery});
            }
            else{
              if(this.$route.path===`/${this.pluralLower}`) await this.$router.push({path: `/${this.pluralLower}`, query: newQuery});
            }
            this.updatingRoute = false;
          }
          //used for pagination end

        } catch (error) {
          console.error(error);
          this.snack(error.msg || error.msg?.message || error, "error");
        } finally {
          this.pagination.loading = false;
          this.loader = false;
        }
      }
    }
  }
</script>
